import styled from 'styled-components'

import Tag from '~/shared/components/tags/Tag'

function PhotographerGuide() {
  return (
    <Wrapper>
      <Title>사진사 참가자의 활동 가이드 및 기타 참고사항</Title>
      <TagBox>
        <Tag $size={'md'} $variant={'gray'}>
          활동 가이드
        </Tag>
        <Desc>
          사진사 참가자의 경우 별도의 입장권을 판매하지 않으며, 일반 입장권을
          구매하여 입장하신 후 출입구 옆 본부석에서 사진사 등록을 하신 뒤
          활동하실 수 있습니다.
          <br />
          <br />
          *본 행사에서의 ‘사진사’란, 휴대폰에 부속된 기본적인 촬영 장치가 아닌
          별도의 촬영장비(DSLR, 미러리스, 디지털 카메라 등)로 촬영하고자 하는
          사람을 지칭하며, 등록 없는 촬영 행위가 적발 될 경우 강제 퇴장
          조치합니다.
          <br />
          <br />
          *서클 부스 참가자가 본인의 서클을 촬영하는 것은 별도의 사진사 등록이
          필요하지 않습니다. 단, 이때 다른 참가자의 얼굴이 나오지 않도록
          주의하여야 합니다.
          <br />
          <br />
          *코스프레 참가자분의 경우, 자동으로 사진사 자격도 부여됩니다.
          <br />
          <br />
          *등록된 사진사라 할지라도 불건전한 의도의 촬영은 금지됩니다. 코스프레
          참가자분에게 무리하거나 수치심이 들 수 있는 포즈 요구 및 언행은 엄격히
          금지하고 있으며, 적발 시 즉시 퇴장조치 및 필요시 경찰 등 관계 기관에
          인계됩니다. 불순한 의도를 가진 사진사를 발견하였다면 즉시 스태프에게
          신고 부탁드립니다.
          <br />
          <br />
          *유튜브 등 영상 실황 중계와 영상 촬영은 사진사 등록 여부와 무관하게
          절대 불가합니다.
        </Desc>
      </TagBox>
      <TagBox>
        <Tag $size={'md'} $variant={'gray'}>
          참고 사항
        </Tag>
        <Desc>
          코스프레는 활동적이며 밖으로 드러나는 취미 활동이기에 서브 컬쳐를
          즐기는 분들은 물론 많은 행인들로부터도 여러 이목이 쏠리게 됩니다.
          그러나 이러한 특성으로 인해 작은 사건 사고에도 코스프레에 대한 인식이
          악화되고, 서브 컬쳐 전반에 대한 이미지 실추는 물론 동인 행사 개최
          자체에도 큰 지장이 생길 수 있기에 코스프레 관련 참가자분들께 아래
          주의사항을 잘 지켜 주시고 질서 유지에 신경써 주시길 부탁 드립니다.
          차회 일러스타 페스에서도 코스플레이어분들과 함께 할 수 있도록 양해와
          협조 부탁드립니다.
        </Desc>
      </TagBox>
    </Wrapper>
  )
}

export default PhotographerGuide

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  height: auto;
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`
const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;
`
const Desc = styled.p`
  font-size: 18px;
  line-height: 25px;
`

const TagBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
